import 'firebase/database';
import { get } from '../helpers/fetchSagaAPI';

export const publisherPlanUsage = function* (token) {
  return yield get('/api/publishers/usage', { headers: { token } });
};
